export { default } from './ProofOfSources';



// WEBPACK FOOTER //
// ./src/components/ProofOfSources/index.js